export var DefaultTags;
(function (DefaultTags) {
    DefaultTags["MATERIAL"] = "Material";
    DefaultTags["LOCATION"] = "Location";
    DefaultTags["TRADE"] = "Trade";
})(DefaultTags || (DefaultTags = {}));
